import isEmpty from 'lodash/isEmpty';
import { useQuery } from '@apollo/client';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { FilteredSpecialsDocument, FilteredSpecialsV2Document } from 'src/gql/graphql';
import type { FilteredSpecialsQuery, FilteredSpecialsV2Query, Specials, Products } from 'src/gql/graphql';

export type ProductOffersInput = Pick<Products, 'DispensaryID' | 'specialData'>;

export default function useProductOffers(product: ProductOffersInput): { specials: Specials[]; loading: boolean } {
  const flags = useFlags();
  const useV2Query = flags['fintech.cats.use-filteredSpecialsV2-outside-admin.rollout'];

  const document = useV2Query ? FilteredSpecialsV2Document : FilteredSpecialsDocument;

  const { data, loading } = useQuery(document, {
    skip: isEmpty(product.specialData?.bogoSpecials),
    variables: {
      specialsFilter: {
        dispensaryId: product.DispensaryID,
        current: true,
        specialIds: (product.specialData?.bogoSpecials ?? [])
          .map((s) => s?.specialId)
          .filter((id): id is string => id != null),
      },
    },
  });

  const result = data as (FilteredSpecialsQuery & FilteredSpecialsV2Query) | undefined;
  const specials = (result?.filteredSpecialsV2?.specials ?? result?.filteredSpecials?.specials ?? []).filter(
    (s): s is Specials => s != null
  );

  return { specials, loading };
}
